export const szVisitTypeList = [
  {
    type: 1,
    value: '医生'
  },
  {
    type: 2,
    value: '等级医院医生'
  },
  {
    type: 3,
    value: '基层医疗机构医生'
  },
  {
    type: 6,
    value: '等级医院科室'
  },
  {
    type: 9,
    value: '医药商业公司客户'
  },
  {
    type: 10,
    value: '零售药店客户'
  },
  {
    type: 11,
    value: '零售药店'
  },
  {
    type: 12,
    value: '医药商业公司'
  },
  {
    type: 13,
    value: '患者'
  },
  {
    type: 14,
    value: '医院科室'
  },
  {
    type: 15,
    value: '等级医院'
  },
  {
    type: 16,
    value: '基层医疗机构'
  },
  {
    type: 17,
    value: '代理商'
  }
];
